import Http from '@/api/http.js'

export default {

  index() {
    return Http.get(`/statuses`)
  }
}
